<template>
  <div
    class="login-panel"
    :class="{ 'login-panel_xs': xs }"
  >
    <div class="login-panel__header">
      <div class="login-panel__back" v-if="backRouteName">
        <router-link :to="{ name: backRouteName }">
          <img src="/static/imgs/orange-left-arrow.png" alt="">
        </router-link>
      </div>
      <div
        class="login-panel__slot-header"
        :class="{ 'login-panel__slot-header_has-back-btn': hasBackBtn }"
      >
        <slot name="login-panel-header"></slot>
      </div>
    </div>
    <div class="login-panel__body">
      <slot></slot>
    </div>
    <div :class="{ 'login-panel__footer': enableFooterDefaultClass }" v-if="hasFooter">
      <slot name="login-panel-footer"></slot>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    backRouteName: {
      type: String,
    },
    xs: {
      type: Boolean,
    },
    enableFooterDefaultClass: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    hasFooter() {
      return !!this.$slots['login-panel-footer'];
    },
    hasBackBtn() {
      return !!this.backRouteName;
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"
@import "src/styles/defaults/mobile-first"
@import "src/styles/defaults/mixins"

.login-panel
  display: flex
  flex-direction: column
  flex-shrink: 0
  background-color: var(--color-page-background)
  border-radius: 3px
  max-height: 90%
  min-height: 500px
  +md-box-shadow-3
  &_xs
    width: 400px
  &__header
    display: flex
    position: relative
    flex-shrink: 0
  &__back
    margin-right: 15px
    position: absolute
    left: 15px
    top: 15px
    width: 25px
    img
      width: 100%
  &__slot-header
    padding: 15px 40px
    &_has-back-btn
      margin-left: 15px
  &__body
    padding: 20px 40px
    flex: 1
    display: flex
    flex-direction: column
    overflow: auto
  &__footer
    flex-shrink: 0
    border-top: 1px solid var(--color-border-dark)
    background-color: var(--color-background-light)
    padding: 20px
    border-radius: 0 0 3px 3px
  +media-min-sm()
  +media-min-md()
  +media-min-lg()
</style>
